import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone } from "lucide-react";

// Public footer — solid black, as on the Spark Coaching website. The Admin link is visible but grants nothing.
export const PublicFooter = () => (
  <footer data-testid="public-footer" className="bg-black text-white">
    <div className="spark-container pt-16 pb-10">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <img src="/brand/lockup_white.png" alt="Spark Coaching" className="h-12 w-auto" />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/70">
            Self-guided career coaching, built from years of evidence-based practice. Find your direction, then make your move.
          </p>
        </div>
        <div className="md:col-span-3">
          <h3 className="text-white text-base font-semibold">Navigate</h3>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            <li><Link to="/" data-testid="footer-home-link" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link to="/signin" data-testid="footer-signin-link" className="hover:text-white transition-colors">Sign in</Link></li>
            <li><Link to="/welcome-note?review=1" data-testid="footer-privacy-link" className="hover:text-white transition-colors">About privacy</Link></li>
            <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors opacity-60">Admin</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <h3 className="text-white text-base font-semibold">Contact</h3>
          <ul className="mt-5 space-y-3 text-sm text-white/70">
            <li><a href="mailto:kate@sparkcoaching.com.au" data-testid="footer-email-link" className="inline-flex items-center gap-3 hover:text-white transition-colors"><Mail size={16} strokeWidth={1.5} />kate@sparkcoaching.com.au</a></li>
            <li><a href="tel:+61403037949" data-testid="footer-phone-link" className="inline-flex items-center gap-3 hover:text-white transition-colors"><Phone size={16} strokeWidth={1.5} />+61 403 037 949</a></li>
            <li><a href="https://www.linkedin.com" target="_blank" rel="noreferrer" data-testid="footer-linkedin-link" className="inline-flex items-center gap-3 hover:text-white transition-colors"><Linkedin size={16} strokeWidth={1.5} />LinkedIn</a></li>
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-6 flex flex-wrap items-center justify-between gap-3 text-xs text-white/50" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
        <span>Spark is career coaching, not therapy or diagnosis. Your reflections belong to you.</span>
        <span>Reflections are drafted with AI, and Spark always checks its understanding with you.</span>
      </div>
    </div>
  </footer>
);

export default PublicFooter;
